// extracted by mini-css-extract-plugin
export default {"root":"FaceInfoTooltip__root--3yDBR","text":"FaceInfoTooltip__text--31Xws","close":"FaceInfoTooltip__close--2d2Ts","button":"FaceInfoTooltip__button--1OOpG"};